"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkDictation = checkDictation;
const textProcessing_1 = require("./textProcessing");
function checkDictation(expected, got, options = {}) {
    const eTok = (0, textProcessing_1.tokenizeSimple)(expected).map((t) => options.caseSensitive ? t.value : (0, textProcessing_1.normalizeToken)(t.value));
    const gTok = (0, textProcessing_1.tokenizeSimple)(got).map((t) => options.caseSensitive ? t.value : (0, textProcessing_1.normalizeToken)(t.value));
    const errors = [];
    const max = Math.max(eTok.length, gTok.length);
    let correct = 0;
    for (let i = 0; i < max; i++) {
        const e = eTok[i];
        const g = gTok[i];
        if (e === undefined && g !== undefined)
            errors.push({ type: "extra", got: g, at: i });
        else if (e !== undefined && g === undefined)
            errors.push({ type: "missing", expected: e, at: i });
        else if (e !== g)
            errors.push({ type: "mismatch", expected: e, got: g, at: i });
        else
            correct += 1;
    }
    const accuracy = eTok.length === 0 ? (gTok.length === 0 ? 1 : 0) : correct / eTok.length;
    return { accuracy, errors, expectedTokens: eTok, gotTokens: gTok };
}
//# sourceMappingURL=dictationChecker.js.map